import { dataEllipsisVertical } from 'dls-icons-data'
import { createIcon } from '../common'

const IconEllipsisVertical = /*#__PURE__*/createIcon(dataEllipsisVertical)
export default IconEllipsisVertical
